<template>
	<div class="editable-button" :class="{ 'is-disabled': isDisabled }">
		<div class="editable-button__content">
			<span class="editable-button__text">{{ text }}</span>
			<div
				v-if="!isDisabled"
				class="editable-button__icon icon-edit-dark-16"
			/>
		</div>
	</div>
</template>

<script lang="ts" setup>
interface Props {
	text: string;
	isDisabled?: boolean;
}

const { text, isDisabled = false } = defineProps<Props>();
</script>

<style lang="scss" scoped>
.editable-button {
	position: relative;
	box-shadow: inset 0 0 0.5rem 0 #20150b;
	border-width: 0.075rem;
	border-style: solid;
	border-image-source: linear-gradient(to top, #bd9032, #f0d386);
	border-image-slice: 1;
	background-color: #f2dcb5;
	width: 13.1875rem;
	height: 1.75rem;

	&:not(.is-disabled) {
		cursor: pointer;
	}

	&::before {
		position: absolute;
		top: 0;
		left: 0;
		opacity: 1 !important;
		// NOTE: Multiply blending is better for light colors
		mix-blend-mode: multiply !important;
		background: url($path-images + "backgrounds/textures/marble-texture-bg.avif")
			repeat left;
		background-size: 80%;
		width: 100%;
		height: 100%;
		content: "";
	}

	&__content {
		position: relative;
		width: 100%;
		height: 100%;
		@include flex-row-center;
		gap: 0.25rem;
		z-index: 1;
	}

	&__text {
		flex: 1 1 0;
		padding-left: 0.5rem;
		height: 100%;
		color: #372615;
		font-weight: 500;
		font-size: 0.875rem;
		text-align: center;
		text-transform: uppercase;
		@include text-truncate;
	}

	&__icon {
		flex-shrink: 0;
		margin-right: 0.25rem;
	}
}
</style>
